<template>
<div class="piechart-container" >
    
    <apexchart 
        v-if="!loading"
        type="pie"     
        :options="chartOptions" 
        :series="series"
        ></apexchart>
        
</div>
</template>

<script>

/**
 * @see https://apexcharts.com/vue-chart-demos/pie-charts/simple-pie-chart/
 * @see https://apexcharts.com/docs/installation/#
 * @see view-source:file:///Users/abe/Downloads/apexcharts-bundle/samples/vue/pie/pie-with-image.html
 */
import VueApexCharts from 'vue-apexcharts';

export default {
    name: 'fc-pie-chart',
    components: {
        'apexchart': VueApexCharts,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            // series: [44, 55, 13, 43, 22],
            width: 380,
        };
    },
    computed: {
        series(){
            return this.data.map((item, index) => {
                return parseInt(item.value);
            });
        },
        chartOptions(){
            return {
                chart: {
                    // width: this.width,
                    type: 'pie',
                },
                labels: this.data.map((item, index) => {
                            return item.name;
                        }),
                colors: ['#fb7700', '#008ffb', '#07a770', '#d69009', '#bf253c', '#775dd0'],
                responsive: [{
                    breakpoint: 767,
                    options: {
                        // chart: {
                        //     width: 200,
                        // },
                        legend: {
                            position: 'bottom',
                        }
                    }
                }],
                plotOptions: {
                    pie: {
                        expandOnClick: true,
                    }
                },
                legend: {
                    position: 'bottom',
                },
            };
        },
    },
}
</script>